/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 23/05/2025 13:20
 *
 */

import { Injectable } from '@angular/core';
import { AuthorizationService } from '@infodata-group/inf-commons';
import { from, mergeMap, Observable, Subject, tap } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { SavePassword } from 'capacitor-ios-autofill-save-password';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';

@Injectable({
  providedIn: 'root',
})
export class CapacitorAuthorizationService extends AuthorizationService {
  private username: string;
  private password: string;

  override clear(): void {
    this.cookieService.clear(document.domain);
    this.getUsername$()
      .pipe(mergeMap(() => this.getPassword$()))
      .subscribe({
        next: () => {
          localStorage.clear();
          if (this.username) {
            SecureStoragePlugin.set({ key: 'username', value: this.username });
          }
          if (this.password) {
            SecureStoragePlugin.set({ key: 'password', value: this.password });
          }
        },
      });
    sessionStorage.clear();
    this.settings.clear();
    this.isAuthenticated = false;
    this.user = null;
  }

  private getUsername$(): Observable<void | { value: string }> {
    return from(SecureStoragePlugin.get({ key: 'username' })).pipe(
      tap((data) => {
        if (data) {
          this.username = data.value;
        }
      }),
    );
  }

  private getPassword$(): Observable<void | { value: string }> {
    return from(SecureStoragePlugin.get({ key: 'password' })).pipe(
      tap((data) => {
        if (data) {
          this.password = data.value;
        }
      }),
    );
  }

  protected override authenticate(body: any): Observable<boolean> {
    console.log('authenticate', body);
    const subject = new Subject<boolean>();
    super.authenticate(body).subscribe({
      next: (isAuthenticated: boolean) => {
        if (isAuthenticated && Capacitor && Capacitor.getPlatform() === 'ios') {
          SavePassword.promptDialog({
            username: body.usr,
            password: body.pwd,
          }).then(() => {
            subject.next(isAuthenticated);
            subject.complete();
          });
        }
      },
      error: (error) => {
        subject.error(error);
        subject.complete();
      },
    });
    return subject.asObservable();
  }
}
